export const STORAGE_NAME = 'drmStorage';
